// src/pages/Presensi.js  (replace your current file with this)
import React, { useState, useMemo, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import TwoColumnLayout from "../layouts/TwoColumnLayout";
import PresensiCardAgendaInfo from "../components/PresensiCardAgendaInfo";
import CardPresensiUmatInfo from "../components/PresensiCardUmatInfo";
import PresensiCardParticipantItem from "../components/PresensiCardParticipantItem";
import PresensiTopHeaderControl from "../components/PresensiTopHeaderControl";
import PresensiSearchFilterBar from "../components/PresensiSearchFilterBar";
import { computeEventStats, getNonUmatData } from "../utils/presensiUtils"; // for stats / gender logic
import { fetchAgendaById } from "../utils/presensiApi.js";
import { getUser } from "../utils/auth";
import { apiFetch } from "../utils/wkCommon";
import { exportPresensiToGoogleSheet } from "../components/PresensiExportSheets";
import AgendaAttributeConfigModal from "../components/AgendaAttributeConfigModal";

const today = new Date().toISOString().slice(0,10);
const dateRange = (s,e)=>{for(var a=[],d=new Date(s);d<=new Date(e);d.setDate(d.getDate()+1))a.push(d.toISOString().slice(0,10));return a};
const authUser = getUser();

/* ---------- dummy data (content-type shapes) ---------- */
const DUMMY_AREAS = [{ id: 11, name: "Taman Palem" }, { id: 12, name: "Tanah Pasir" }];

const DUMMY_UMATS = [
  { id: 101, umatID: "ZI15", fullName: "Viola Stanly / Ola", chineseName: "", pinyinName: "", nickName: "Ola", gender: "F", area: DUMMY_AREAS[0], avatar: null },
  { id: 102, umatID: "QA08", fullName: "Gisella Chang / Gisel", chineseName: "張姬瑟", pinyinName: "Zhang Ji-se", nickName: "Gisel", gender: "F", area: DUMMY_AREAS[1], avatar: null },
  { id: 103, umatID: "RB25", fullName: "Budi Santoso", chineseName: "", pinyinName: "", nickName: "Budi", gender: "M", area: DUMMY_AREAS[0], avatar: null },
];

const DUMMY_FOTANG = { id: 201, fotangNameCH: "佛堂A", fotangNamePinyin: "Fotang A" };
const DUMMY_EXTERNAL = [{ id: 301, name: "John Doe", gender: "M", address: "Jl. Mawar 3", fotang_external: DUMMY_FOTANG, fotangExternalOtherDesc: null }];

/* --- updated dummyAgenda to match new content-type shapes --- */
const dummyAgenda = {
  id: "a1",
  subject: "Kelas Paritta Anak-anak",
  agendaDate: "2024-08-04",
  agendaDateEnd: "2024-08-06",
  area: "Kelapa Gading",
  allowUmatExternal: true,
  allowPublic: true,
  oneTimeTagNumber: true,
  events: [
    {
      id: "e1",
      eventDate: "2024-08-04",
      participants: [
        { id: "p1", peserta: true, personType: "Internal", umat: DUMMY_UMATS[0], external_person: null, donationAmount: 0, isPresent: true, seqNo: 1 },
        { id: "p2", peserta: true, personType: "Internal", umat: DUMMY_UMATS[1], external_person: null, donationAmount: 25000, isPresent: true, seqNo: 2 },
        { id: "p3", peserta: false, personType: "Internal", umat: DUMMY_UMATS[2], external_person: null, donationAmount: 60000, isPresent: false, posName: "Ustad" },
      ],
    },
    {
      id: "e2",
      eventDate: "2024-08-05",
      participants: [
        { id: "p4", peserta: true, personType: "External", umat: null, external_person: { id: "ext301", name: "John External", gender: "M", address: "Jl. Mawar 3", fotang_external: DUMMY_FOTANG }, donationAmount: 20000, isPresent: true, seqNo: 1 }
      ],
    },
    { id: "e3", eventDate: "2024-08-06", participants: [] },
  ],
  preRegistrations: [
    { id: "pr1", eventId: "e1", peserta: true, personType: "Internal", umat: DUMMY_UMATS[0], external_person: null, isPresent: false },
    { id: "pr2", eventId: "e1", peserta: false, personType: "External", umat: null, external_person: DUMMY_EXTERNAL[0], isPresent: false, petugasRoleDesc: "Sekretariat" },
    { id: "pr3", eventId: "e1", peserta: true, personType: "NonUmat", umat: null, external_person: null, nonUmatName: "Mr NonUmat", nonUmatGender: "M", nonUmatAge: "45", nonUmatPhoneNo: "08123456789", nonUmatRemarks: "Tamu dari komunitas", isPresent: false },
  ],
};

const rem = (n) => `${n}rem`;

export default function Presensi() {
  const [q, setQ] = useState("");
  const [roleFilter, setRoleFilter] = useState("all");
  const [genderFilter, setGenderFilter] = useState("all");
  const [sortBy, setSortBy] = useState("name");
  const [showDonation, setShowDonation] = useState(false);
  const [showPreReg, setShowPreReg] = useState(true);

  const history = useHistory();
  const location = useLocation();
  const agendaDocId = useParams();

  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false);

  // state tambahan
  const [loading, setLoading] = useState(false);
  const [selectedAgenda, setSelectedAgenda] = useState(null);
  
  const [deleteTarget, setDeleteTarget] = useState(null);

  const [debugLogs, setDebugLogs] = useState([]);
  const [externalError, setExternalError] = useState(null);
  const isBlocked = !!externalError;

  const [showAttrModal, setShowAttrModal] = useState(false);

  function pushDebugLog(participant, meta = {}) {
    if (!participant) return;

    const list = Array.isArray(participant) ? participant : [participant];

    const entries = list.map(p => {
      const personType = p.personType || "-";
      const role = p.peserta ? "Peserta" : "Petugas";

      const umat = p.umat;
      const ext = p.external_person;

      const n = getNonUmatData(p);

      const name =
        umat?.fullName ||
        ext?.name ||
        n.name ||
        "-";

      const genderRaw =
        umat?.gender ||
        ext?.gender ||
        n.gender ||
        "-";      

      const multiple =
        Array.isArray(participant) ? "Multiple" : "Single";

      return {
        time: new Date().toISOString(),
        mode: meta?.mode || "-",
        role,
        gender: genderRaw,
        personType,
        name,
        multiple,
        raw: p
      };
    });

    setDebugLogs(prev => [...entries, ...prev].slice(0, 20)); // keep last 20
  }

  // helper: sinkronkan participants ke selectedAgenda.events untuk event yg aktif
  function syncSelectedAgendaParticipants(newParticipants) {
    setSelectedAgenda(prev => {
      if (!prev) return prev;
      const evs = (prev.events || []).map(ev => {
        if (String(ev.id) === String(selectedEventId)) {
          return { ...ev, participants: Array.isArray(newParticipants) ? newParticipants : (ev.participants || []) };
        }
        return ev;
      });
      return { ...prev, events: evs };
    });
  }

  // derive events safely
  const events = selectedAgenda?.events ?? [];
  const firstEventId = events.length ? events[0].id : null;
  const [lastExportUrl, setLastExportUrl] = useState(null);

  // state: sumber kebenaran lokal
  const [selectedEventId, setSelectedEventId] = useState(firstEventId);
  const [agendaPreRegistrations, setAgendaPreRegistrations] = useState(() => selectedAgenda?.preRegistrations ?? []);
  const [eventParticipants, setEventParticipants] = useState(() => (events.find(e=>e.id===firstEventId)?.participants) ?? []);

  // effect: load agenda + create events if missing
  useEffect(()=> {
    if (!agendaDocId) return;
    const ac = new AbortController();
    let mounted = true;
    (async ()=> {
      try {
        setLoading(true);
        const aResp = await fetchAgendaById(agendaDocId.id, { signal: ac.signal });
        if (!mounted) return;
        let a = aResp?.data ?? aResp;

        if (!a?.area) {
          setExternalError(
            "Kegiatan pusat/eksternal - tidak dapat membuat data presensi.\n中心或外部活動－無法建立出席資料。"
          );
          console.warn("Agenda has no area — stopping process.");
          setSelectedAgenda(a);
          return;
        }

        // create events if empty, then re-fetch to get populated events
        if (!Array.isArray(a.events) || a.events.length === 0) {
          for (const eventDate of dateRange(a.agendaDate, a.agendaDateEnd ? a.agendaDateEnd : a.agendaDate)) {
            try {
              const evResp = await apiFetch("/api/events", { method: "POST", body: { data: { eventDate, agenda: a.id, recordOwner: authUser?.username, recordEditor: authUser?.username } } });

              const ev = evResp?.data ?? evResp; // event created
              setSelectedAgenda(prev => ({ ...prev, events: [ ...(prev?.events||[]), ev ] }));
            } catch(e) {
              console.error("Failed to create event for", eventDate, e);
            }
          }
          const aResp2 = await fetchAgendaById(a.documentId, { signal: ac.signal });
          if (!mounted) return;
          a = aResp2?.data ?? aResp2;
        }

        setSelectedAgenda(a);
      } catch(err) {
        if (err?.name === "AbortError") console.log("fetch aborted");
        else console.error(err);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return ()=> { mounted = false; ac.abort(); };
  }, [agendaDocId?.id]);

  // sync ketika selectedAgenda berubah
  useEffect(()=> {
    const evs = selectedAgenda?.events ?? [];
    const newDefault = evs.length ? evs[0].id : null;

    setSelectedEventId(prev => (prev && evs.find(e=>e.id===prev)) ? prev : newDefault);
    setAgendaPreRegistrations(selectedAgenda?.preRegistrations ?? []);
    setEventParticipants(
      ((selectedAgenda?.events?.find(e=>e.id=== newDefault)?.participants) ?? [])
      .filter(p => !p.deleted)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAgenda]);

  // sync ketika selectedEventId berubah
  useEffect(()=> {
    const participants =
      (selectedAgenda?.events?.find(e =>
        String(e.id) === String(selectedEventId)
      )?.participants ?? [])
      .filter(p => !p.deleted);

    setEventParticipants(participants);
  }, [selectedEventId, selectedAgenda]);

  // reservation counters for UI session to avoid duplicate nextSeq in same client
  const [reservedNext, setReservedNext] = useState({ M: 0, F: 0 });

  // compute last seq BY SCANNING participants (tidy, safe)
  function computeLastSeqByGenderFromParticipants(participants = []) {
    const last = { M: 0, F: 0 };
    (participants || []).forEach(p => {
      if (!p) return;
      const s = Number(p.seqNo || 0);
      const n = getNonUmatData(p);
      const gender = (p.personType === "Internal" && p.umat && String(p.umat.gender || "").toLowerCase())
        || (p.personType === "External" && p.external_person && String(p.external_person.gender || "").toLowerCase())
        || (p.personType === "NonUmat" && String(n.gender || "").toLowerCase())
        || "";
      const male = gender.startsWith("m") || gender === "male" || gender === "l" || gender.startsWith("乾");
      if (!isNaN(s) && s > 0) {
        if (male) last.M = Math.max(last.M, s);
        else last.F = Math.max(last.F, s);
      }
    });
    return last;
  }

  const lastSeqMap = useMemo(()=> computeLastSeqByGenderFromParticipants(eventParticipants), [eventParticipants]);

  function getNextSeqNo(genderKey) {
    if (!genderKey) return null;
    const base = (lastSeqMap[genderKey] || 0);
    const reserved = (reservedNext[genderKey] || 0);
    const next = base + reserved + 1;
    setReservedNext(prev => ({ ...prev, [genderKey]: (prev[genderKey] || 0) + 1 }));
    return next;
  }

  // firstEventSeqMap (safe)
  const firstEventSeqMap = useMemo(() => {
    const map = new Map();
    if (!firstEventId) return map;
    const firstEv = selectedAgenda?.events?.find(e => String(e.id) === String(firstEventId));
    if (!firstEv) return map;
    (firstEv.participants || []).filter(p => !p.deleted).forEach(p => {
      if (p.personType === "Internal" && p.umat && (p.umat.id || p.umat.umatID)) {
        const key = `I:${p.umat.id ?? p.umat.umatID}`;
        map.set(key, Number(p.seqNo || null));
      } else if (p.personType === "External" && p.external_person && (p.external_person.id || p.external_person.name)) {
        const key = `E:${p.external_person.id ?? p.external_person.name}`;
        map.set(key, Number(p.seqNo || null));
      } else if (p.personType === "NonUmat") {
        const n = getNonUmatData(p);
        const key = p.preRegistrationId ? `NPR:${p.preRegistrationId}` : `N:${n.name}:${n.phone}`;
        map.set(key, Number(p.seqNo || null));
      }
    });
    return map;
  }, [selectedAgenda, firstEventId]);

  function lookupSeqFromFirstEvent(participant) {
    if (!firstEventSeqMap) return null;
    if (participant.personType === "Internal" && participant.umat) {
      const key = `I:${participant.umat.id ?? participant.umat.umatID}`;
      return firstEventSeqMap.has(key) ? firstEventSeqMap.get(key) : null;
    }
    if (participant.personType === "External" && participant.external_person) {
      const key = `E:${participant.external_person.id ?? participant.external_person.name}`;
      return firstEventSeqMap.has(key) ? firstEventSeqMap.get(key) : null;
    }
    if (participant.personType === "NonUmat") {
      const key = participant.preRegistrationId ? `NPR:${participant.preRegistrationId}` : `N:${(participant.nonUmatName||"")}:${(participant.nonUmatPhoneNo||"")}`;
      return firstEventSeqMap.has(key) ? firstEventSeqMap.get(key) : null;
    }
    return null;
  }

  function sameId(a, b) {
    if (a == null || b == null) return false;
    return String(a) === String(b);
  }
  function findMatchingPreReg(participant) {
    if (!agendaPreRegistrations || !Array.isArray(agendaPreRegistrations)) return null;

    return agendaPreRegistrations.find((pr) => {
      if (pr.eventId && pr.eventId !== selectedEventId) return false;

      const pType = participant.personType || (participant._isPrereg && participant.umat ? "Internal" : participant.external_person ? "External" : "NonUmat");

      if (pType === "Internal") {
        const prU = pr.umat || {};
        const partU = participant.umat || {};
        return pr.personType === "Internal" && (sameId(prU.id ?? prU.documentId ?? prU.umatID, partU.id ?? partU.documentId ?? partU.umatID));
      }

      if (pType === "External") {
        const prE = pr.external_person || {};
        const partE = participant.external_person || {};
        return pr.personType === "External" && (sameId(prE.id ?? prE.documentId ?? prE.email ?? prE.name, partE.id ?? partE.documentId ?? partE.email ?? partE.name));
      }

      if (pType === "NonUmat") {
        if (pr.personType !== "NonUmat") return false;
        if (participant.preRegistrationId && pr.id) return sameId(pr.id, participant.preRegistrationId);

        const n = getNonUmatData(participant);
        if (pr.nonUmatName && n.name && pr.nonUmatName === n.name) return true;
        if (pr.nonUmatPhoneNo && n.phone && pr.nonUmatPhoneNo === n.phone) return true;
        return false;
      }

      if (pr.id && participant.preRegistrationId) return sameId(pr.id, participant.preRegistrationId);

      return false;
    }) || null;
  }

  function getDisplayName(p) {
    const umat = p.umat;
    const ext = p.external_person;
    const n = getNonUmatData(p);

    const isExternal = !!ext;
    const isNonUmat = p.personType === "NonUmat";

    if (isExternal) {
      return ext?.name || "";
    }

    if (isNonUmat) {
      return n.name || "";
    }

    // INTERNAL (harus sama dengan card)
    return umat?.pinyinName || umat?.fullName || umat?.nickName || umat?.chineseName || "";
  }

  // merge participants + pre-registrations for display
  const filteredParticipants = useMemo(() => {
    let list = [...(eventParticipants || [])]
      .filter(p => !p.deleted);

    if (showPreReg) {
      const preRegsForEvent = (agendaPreRegistrations || []).filter(pr => {
        if (pr.eventId && pr.eventId !== selectedEventId) return false;
        return true;
      });

      const existingKeys = new Set(
        (list || []).map(p => (
          p.id
          || (p.personType === "Internal" && p.umat && (p.umat.umatID || p.umat.kode))
          || (p.personType === "External" && p.external_person && (p.external_person.email || p.external_person.name))
          || (p.personType === "NonUmat" && (p.non_umat_pre_registration?.nonUmatName || p.external_person?.name))
          || JSON.stringify(p)
        ))
      );

      const dedupedPreRegs = preRegsForEvent.filter(pr => {
        if (pr.isPresent) return false;

        const key = pr.id
          || (pr.personType === "Internal" && pr.umat && (pr.umat.umatID || pr.umat.kode))
          || (pr.personType === "External" && pr.external_person && (pr.external_person.email || pr.external_person.name))
          || (pr.personType === "NonUmat" && (pr.nonUmatName || JSON.stringify({name: pr.nonUmatName, phone: pr.nonUmatPhoneNo})))
          || JSON.stringify(pr);

        return !existingKeys.has(key);
      }).map(pr => {
        return { ...pr, _isPrereg: true, _isPreReg: true };
      });

      list = [...dedupedPreRegs, ...list];
    }

    const qLower = (q || "").trim().toLowerCase();

    if (qLower) {
      list = list.filter(p => {
        const u = p.umat;
        const e = p.external_person;
        const nu = getNonUmatData(p); //umum / non-umat


        const candidates = [
          u?.fullName,
          u?.displayName,
          u?.nickName,
          u?.chineseName,
          u?.pinyinName,
          u?.umatID,
          e?.name,
          nu?.name,
          nu?.phone,
          nu?.remarks,
        ]
          .filter(Boolean)
          .map(v => String(v).toLowerCase());

        return candidates.some(v => v.includes(qLower));
      });
    }

    if (roleFilter !== "all") {
      if (roleFilter === "peserta") list = list.filter(p => p.peserta);
      if (roleFilter === "petugas") list = list.filter(p => p.peserta === false);
    }
    if (genderFilter !== "all") {
      list = list.filter(p => {
        const n = getNonUmatData(p);

        const g = (
          p.umat?.gender ||
          p.external_person?.gender ||
          n.gender ||
          ""
        ).toString().toLowerCase();

        if (genderFilter === "male") return g.startsWith("m") || g.startsWith("乾");
        if (genderFilter === "female") return g.startsWith("f") || g.startsWith("坤");
        return true;
      });
    }

    if (sortBy === "name") {
      list.sort((a, b) => {
        const aName = getDisplayName(a).toLowerCase().trim();
        const bName = getDisplayName(b).toLowerCase().trim();

        return aName.localeCompare(bName);
      });
    } else if (sortBy === "seqNo") {
      list.sort((a, b) => (a.seqNo || 0) - (b.seqNo || 0));
    }

    return list;
  }, [eventParticipants, agendaPreRegistrations, showPreReg, q, roleFilter, genderFilter, sortBy, selectedEventId]);

  function participantsPanelTitle() {
    if (roleFilter === "peserta") return "班員名單 Daftar Hadir Peserta";
    if (roleFilter === "petugas") return "辦事人員名單 Daftar Hadir Petugas";
    return "名單 Daftar Hadir";
  }

  // header actions
  const headerActions = (
    <>
      <PresensiTopHeaderControl
        agendaId={selectedAgenda?.documentId}
        hasPreRegForm={!!selectedAgenda?.agenda_pre_reg_form}
        onAddById={(kode) => handleAddById(kode ?? "", { asPreReg: true, isExternal: false })}
        onScanQr={() => {
          history.push(`/qrscan?eventId=${selectedEventId}`, { returnTo: location.pathname });
        }}
        onToggleShowDonation={() => setShowDonation(s => !s)}
        showDonation={showDonation}
        onTogglePreRegVisibility={() => setShowPreReg(s => !s)}
        showPreReg={showPreReg}
        onExport={async () => {
          try {
            const resp = await exportPresensiToGoogleSheet(
              eventParticipants,
              selectedAgenda
            );

            if (resp?.url) {
              setLastExportUrl(resp.url);
              const ok = window.confirm("Export berhasil. Buka Google Sheet?");
              if (ok) window.open(resp.url, "_blank");
            } else {
              alert("Export berhasil, tapi link tidak ditemukan");
            }
          } catch (err) {
            console.error(err);
            alert("Export gagal");
          }
        }}
        onGenerateReport={() => console.log("report")}
        onOpenConfig={() => setShowAttrModal(true)}
        onRefresh={async () => {
          try {
            setLoading(true);

            const aResp = await fetchAgendaById(agendaDocId.id);
            const a = aResp?.data ?? aResp;

            setSelectedAgenda(a);
          } catch (err) {
            console.error(err);
            alert("Gagal refresh data");
          } finally {
            setLoading(false);
          }
        }}        
      />
    </>
  );

  const leftNode = (
    <div style={{ padding: rem(0.4) }}>
      { selectedAgenda ? (
        <PresensiCardAgendaInfo
          disabled={isBlocked}
          agenda={selectedAgenda}
          selectedEventId={selectedEventId ? String(selectedEventId) : null}
          onSelectEvent={(id) => setSelectedEventId(id)}
          showDonation={showDonation}
          lastExportUrl={lastExportUrl}
        />
      ) : <div>Loading agenda…</div>}
    </div>
  );

  const isMobile = typeof window !== "undefined" ? window.innerWidth < 720 : false;

  const rightNode = (
    <div style={{ padding: rem(0.8) }}>
      {isBlocked ? (
        <div style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "0.6rem",
          padding: rem(1),
          background: "#fff3f0",
          border: "1px solid #ffb4a8",
          borderRadius: rem(0.6),
          color: "#b91c1c",
          fontWeight: 600,
          whiteSpace: "pre-line"
        }}>
          <div style={{ fontSize: "1.1rem", lineHeight: 1 }}>
            ⚠
          </div>

          <div style={{ lineHeight: 1.4 }}>
            {externalError}
          </div>
        </div>
      ) : (
        <>
        <div style={{ marginTop: rem(0.4), display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: rem(1), fontWeight: 700 }}>{participantsPanelTitle()}</div>
        </div>

        <PresensiSearchFilterBar
          q={q} onQChange={setQ}
          roleFilter={roleFilter} onRoleChange={setRoleFilter}
          genderFilter={genderFilter} onGenderChange={setGenderFilter}
          sortBy={sortBy} onSortChange={setSortBy}
          showDonation={showDonation} onToggleShowDonation={() => setShowDonation(s => !s)}
        />

        <div style={{
          marginTop: rem(0.6),
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          gap: rem(0.85)
        }}>
          {!selectedAgenda || filteredParticipants.length === 0 ? (
            <div style={{ gridColumn: "1 / -1", padding: rem(0.8), borderRadius: rem(0.6), background: "#fff8f0" }}>
              Tidak ada peserta sesuai filter / pencarian.
            </div>
          ) : filteredParticipants.map(p => {
              const match = findMatchingPreReg(p);
              return (
                <PresensiCardParticipantItem
                  key={p.id}
                  participant={p}
                  preRegistration={match}
                  agendaId={selectedAgenda.id}
                  showDonation={showDonation}
                  onClick={() => { setSelectedParticipant(p); setIsAddingNew(false); }}
                  onDelete={(participant) => setDeleteTarget(participant)}   
                />
              );
          })}
        </div>
        </>
      )}
    </div>
  );

  const showModal = !!selectedParticipant || isAddingNew;

  // ---------- existing helper that previously saved to local state ----------
  function handleSaveParticipant(updated = {}) {
    if (!selectedParticipant) return;
    const merged = {
      ...selectedParticipant,
      ...updated,
      umat: { ...(selectedParticipant.umat || {}), ...(updated.umat || {}) },
      external_person: { ...(selectedParticipant.external_person || {}), ...(updated.external_person || {}) },
    };
    const asPreReg = merged._meta_temp ? !!merged._meta_temp.asPreReg : false;
    if (asPreReg) {
      setAgendaPreRegistrations(prev => {
        const idx = prev.findIndex(x => x.id === merged.id);
        if (idx >= 0) { const cp = [...prev]; cp[idx] = merged; 
          // sync selectedAgenda pre-registrations (if you keep them in selectedAgenda)
          setSelectedAgenda(sa => sa ? ({ ...sa, preRegistrations: (sa.preRegistrations || []).map(pr => pr.id === merged.id ? merged : pr) }) : sa);
          return cp;
        }
        // prepend and sync
        setSelectedAgenda(sa => sa ? ({ ...sa, preRegistrations: [merged, ... (sa.preRegistrations||[]) ] }) : sa);
        return [merged, ...prev];
      });
    } else {
      setEventParticipants(prev => {
        const idx = prev.findIndex(x => x.id === merged.id);
        if (idx >= 0) { const cp = [...prev]; cp[idx] = merged;
          // sync participants inside selectedAgenda.events for the active event
          syncSelectedAgendaParticipants(cp);
          return cp;
        }
        const next = [merged, ...prev];
        syncSelectedAgendaParticipants(next);
        return next;
      });
    }
    setSelectedParticipant(null);
    setIsAddingNew(false);
  }

  function normalizeParticipant(resp) {
    if (!resp) return resp;

    const base = resp.attributes ? resp.attributes : resp;

    const docId = resp.documentId || base.documentId;

    if (!docId) {
      console.error("❌ Missing documentId", resp);
      return null;
    }

    return {
      id: resp.id || base.id,
      documentId: docId,
      deleted: base.deleted || null,
      deletedBy: base.deletedBy || null,
      ...base,
      umat: base.umat?.data || base.umat || null,
      external_person: base.external_person?.data || base.external_person || null,
      non_umat_pre_registration:
        base.non_umat_pre_registration?.data ||
        base.non_umat_pre_registration ||
        null,
    };
  }

  // Adapter to accept new editor signature onSave(out, meta)
  function handleSaveFromEditor(out, meta = {}) {
    if (!meta || !meta.mode) {
      handleSaveParticipant(out);
      return;
    }

    if (meta.mode === "create-batch") {
      const arr = Array.isArray(out) ? out : [out];
      //const items = arr.map((it, i) => ({ id: `tmp-batch-${Date.now()}-${i}`, ...it }));
      const items = arr.map(it => normalizeParticipant(it)).filter(Boolean);
      pushDebugLog(items, meta);

      setEventParticipants(prev => {
        const next = [...items, ...prev];
        // sync into selectedAgenda
        syncSelectedAgendaParticipants(next);
        return next;
      });
      setSelectedParticipant(null);
      setIsAddingNew(false);
      return;
    }

    if (meta.mode === "create-from-prereg") {
      //const created = { id: `tmp-${Date.now()}`, ...out };
      const created = normalizeParticipant(out);
      pushDebugLog(created, meta);
      setEventParticipants(prev => {
        const next = [created, ...prev];
        syncSelectedAgendaParticipants(next);
        return next;
      });
      if (meta.preRegistrationId) {
        setAgendaPreRegistrations(prev => {
          const nextPr = prev.map(pr => pr.id === meta.preRegistrationId ? ({ ...pr, isPresent: true }) : pr);
          // sync into selectedAgenda.preRegistrations too
          setSelectedAgenda(sa => sa ? ({ ...sa, preRegistrations: nextPr }) : sa);
          return nextPr;
        });
      }
      setSelectedParticipant(null);
      setIsAddingNew(false);
      return;
    }

    if (meta.mode === "create") {

      //const created = out; 
      const created = normalizeParticipant(out);

      pushDebugLog(created, meta);
      //const created = { id: `tmp-${Date.now()}`, ...out };
      setEventParticipants(prev => {
        const next = [created, ...prev];
        syncSelectedAgendaParticipants(next);
        return next;
      });
      setSelectedParticipant(null);
      setIsAddingNew(false);
      return;
    }

    if (meta.mode === "update") {
      pushDebugLog(out, meta);
      const docId = out.documentId || out.id || selectedParticipant?.documentId || selectedParticipant?.id;
      setEventParticipants(prev => {
        const next = prev.map(p => {
          if ((p.documentId && String(p.documentId) === String(docId)) || String(p.id) === String(docId)) {
            //return { ...p, ...out };
            const normalized = normalizeParticipant(out);
            return { ...p, ...normalized };
          }
          return p;
        });
        syncSelectedAgendaParticipants(next);
        return next;
      });
      setSelectedParticipant(null);
      setIsAddingNew(false);
      return;
    }
  }

  function handleScanQr() {
    history.push("/scan", { returnTo: location.pathname });
  }
  function handleToggleShowDonation() { setShowDonation(s => !s); }
  function handleTogglePreRegVisibility() { setShowPreReg(s => !s); }

  function handleAddById(id, { asPreReg = true, isExternal = false } = {}) {
    if (isExternal) {
      const tmp = {
        id: `tmp-ext-${Date.now()}`,
        peserta: true,
        umat: null,
        external_person: { id: null, name: "", gender: "", address: "", fotang_external: null, fotangExternalOtherDesc: null },
        donationAmount: 0,
        seqNo: null,
        posName: null,
        _meta_temp: { asPreReg, isExternal: true },
      };
      setSelectedParticipant(tmp);
      setIsAddingNew(true);
      return;
    }

    const tmpU = {
      id: `tmp-umat-${Date.now()}`,
      peserta: true,
      umat: { id: null, umatID: id ?? "", fullName: "", chineseName: null, pinyinName: null, nickName: null, gender: null, area: null, avatar: null },
      external_person: null,
      donationAmount: 0,
      seqNo: null,
      posName: null,
      _meta_temp: { asPreReg, isExternal: false },
    };
    setSelectedParticipant(tmpU);
    setIsAddingNew(true);
  }

  return (
    <>
      <TwoColumnLayout
        leftNode={leftNode}
        rightNode={rightNode}
        variant="right70"
        title="Presensi / Kehadiran"
        headerActions={!isBlocked ? headerActions : null}
      />

      <AgendaAttributeConfigModal
        open={showAttrModal}
        onClose={()=>setShowAttrModal(false)}
        agendaId={selectedAgenda?.documentId || selectedAgenda?.id}
        agenda={selectedAgenda}
        agendaBook={selectedAgenda?.agenda_book}
      />

      {deleteTarget && (
        <>
          <div
            onClick={() => setDeleteTarget(null)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.35)",
              zIndex: 200
            }}
          />
          <div style={{
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            background: "#fff",
            borderRadius: "0.75rem",
            boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
            zIndex: 210,
            width: "92%",
            maxWidth: "22rem",
            padding: "1rem",
            boxSizing: "border-box",
          }}>
            <div style={{ fontWeight: 700, marginBottom: "0.75rem" }}>
              Konfirmasi Hapus
            </div>

            <div style={{ marginBottom: "1rem" }}>
              Yakin ingin menghapus participant ini?
            </div>

            <div style={{ 
              display: "flex", 
              gap: "0.5rem", 
              justifyContent: "flex-end",
              flexDirection: window.innerWidth < 480 ? "column" : "row" }}
            >
              <button
                onClick={() => setDeleteTarget(null)}
                style={{
                  padding: "0.5rem 0.8rem",
                  borderRadius: "0.4rem",
                  border: "1px solid #ddd",
                  background: "#fff"
                }}
              >
                Batal
              </button>

              <button
                onClick={async () => {
                  try {
                    if (!deleteTarget?.documentId) {
                      console.error("❌ DELETE without documentId", deleteTarget);
                      alert("Data tidak tersimpan di server");
                      return;
                    }

                    const user = getUser();

                    await apiFetch(
                      `/api/event-participants/${encodeURIComponent(deleteTarget.documentId)}`,
                      {
                        method: "PUT",
                        body: {
                          data: {
                            deleted: new Date().toISOString(),
                            deletedBy: user?.username || "system"
                          }
                        }
                      }
                    );

                    setEventParticipants(prev => {
                      const next = prev.filter(p =>
                        p.documentId !== deleteTarget.documentId
                      );
                      syncSelectedAgendaParticipants(next);
                      return next;
                    });

                    setDeleteTarget(null);

                    // ✅ SUCCESS NOTIF
                    alert("Berhasil menghapus participant");

                  } catch (err) {
                    console.error("Delete failed", err);

                    // ❌ FAILED NOTIF
                    alert("Gagal menghapus participant");
                  }
                }}
                style={{
                  padding: "0.5rem 0.8rem",
                  borderRadius: "0.4rem",
                  border: "none",
                  background: "#dc2626",
                  color: "#fff",
                  fontWeight: 600
                }}
              >
                Hapus
              </button>
            </div>
          </div>
        </>
      )}

      {showModal && (
        <>
          <div
            onClick={() => { setSelectedParticipant(null); setIsAddingNew(false); }}
            style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.32)", zIndex: 120 }}
          />
          <div role="dialog" aria-modal="true" style={{
            position: "fixed", left: "50%", top: "50%", transform: "translate(-50%, -50%)",
            zIndex: 130, width: "92%", maxWidth: "820px", maxHeight: "92vh", overflow: "auto", borderRadius: "12px", boxShadow: "0 20px 50px rgba(2,6,23,0.4)"
          }}>
            <div style={{ background: "#fff", borderRadius: "12px", padding: rem(1) }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: rem(0.6) }}>
                <div style={{ fontWeight: 800 }}>
                  {selectedParticipant?.umat ? (selectedParticipant.umat.fullName || selectedParticipant.umat.umatID) : (selectedParticipant?.external_person?.name || selectedParticipant?.non_umat_pre_registration?.nonUmatName || "New Participant")}
                </div>
              </div>

              <CardPresensiUmatInfo
                participant={selectedParticipant}
                onSave={(out, meta) => handleSaveFromEditor(out, meta)}
                onCancel={() => { setSelectedParticipant(null); setIsAddingNew(false); }}
                getNextSeqNo={getNextSeqNo}
                selectedAgenda={selectedAgenda}
                selectedEventId={selectedEventId}
                firstEventId={firstEventId}
                lookupSeqFromFirstEvent={lookupSeqFromFirstEvent}
              />
            </div>
          </div>
        </>
      )}


    </>
  );
}
